import * as fromDatatype from '../datatype-library/index';

export interface bl_cms_website_schema_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    cms_website_guid: fromDatatype.GuidDataFieldInterface;
    schema_website: fromDatatype.VarcharArrayDatatypeInterface;
    schema_name: fromDatatype.VarcharArrayDatatypeInterface;
    schema_type: fromDatatype.VarcharArrayDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    schema_json: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.VarcharArrayDatatypeInterface;
}

export class bl_cms_website_schema_hdr_RowClass implements bl_cms_website_schema_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    cms_website_guid: fromDatatype.GuidDataFieldInterface;
    schema_website: fromDatatype.VarcharArrayDatatypeInterface;
    schema_name: fromDatatype.VarcharArrayDatatypeInterface;
    schema_type: fromDatatype.VarcharArrayDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    schema_json: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.VarcharArrayDatatypeInterface;
}
